import React from 'react';

import { useLocation } from 'react-router-dom';

import { ImageAvatar } from '~/assets/images';
import IUser from '~/interfaces/user.interface';

import S from './styles';

// eslint-disable-next-line @typescript-eslint/ban-types
type Props = {};

type IState = {
  state: {
    user: IUser;
  };
};

const Genres = {
  other: 'Outros',
  female: 'Feminino',
  male: 'Masculino',
};

const StudentDetails = (Props: Props) => {
  const { state }: IState = useLocation();
  const { user } = state;

  return (
    <S.Container>
      <S.Header>
        <S.StudentPicContainer>
          <S.StudentPic
            src={user.img_url ? user.img_url : ImageAvatar}
            alt="Foto do Aluno"
          />
        </S.StudentPicContainer>

        <S.HeaderInfoContainer>
          <S.HeaderTitle>{user.name}</S.HeaderTitle>
          <S.HeaderSubTitle>
            Data de cadastro:{' '}
            {user.created_at
              .split(' ')[0]
              .split('-')
              .reverse()
              .join()
              .replaceAll(',', '/') || ''}
          </S.HeaderSubTitle>
        </S.HeaderInfoContainer>
      </S.Header>

      <S.Main>
        <S.StudentDataColumn>
          <S.StudentDataContainer>
            <S.StudentDataTitle>Nome</S.StudentDataTitle>
            <S.StudentDataSubTitle>{user.name}</S.StudentDataSubTitle>
          </S.StudentDataContainer>

          <S.StudentDataContainer>
            <S.StudentDataTitle>Data de nascimento</S.StudentDataTitle>
            <S.StudentDataSubTitle>
              {user.student?.birth_date
                .split('-')
                .reverse()
                .join()
                .replaceAll(',', '/')}
            </S.StudentDataSubTitle>
          </S.StudentDataContainer>

          <S.StudentDataContainer>
            <S.StudentDataTitle>Idade</S.StudentDataTitle>
            <S.StudentDataSubTitle>{user.name}</S.StudentDataSubTitle>
          </S.StudentDataContainer>

          <S.StudentDataContainer>
            <S.StudentDataTitle>Gênero</S.StudentDataTitle>
            <S.StudentDataSubTitle>
              {user.student?.genre
                ? Genres[user.student.genre]
                : 'Não informado'}
            </S.StudentDataSubTitle>
          </S.StudentDataContainer>

          <S.StudentDataContainer>
            <S.StudentDataTitle>CPF</S.StudentDataTitle>
            <S.StudentDataSubTitle>{user.student?.cpf}</S.StudentDataSubTitle>
          </S.StudentDataContainer>

          <S.StudentDataContainer>
            <S.StudentDataTitle>Celular</S.StudentDataTitle>
            <S.StudentDataSubTitle>
              {user.cellphone || 'Não informado'}
            </S.StudentDataSubTitle>
          </S.StudentDataContainer>

          <S.StudentDataContainer>
            <S.StudentDataTitle>Email</S.StudentDataTitle>
            <S.StudentDataSubTitle>{user.email}</S.StudentDataSubTitle>
          </S.StudentDataContainer>
        </S.StudentDataColumn>

        <S.StudentDataColumn>
          <S.StudentDataContainer>
            <S.StudentDataTitle>País</S.StudentDataTitle>
            <S.StudentDataSubTitle>
              {user.address_country || 'Não informado'}
            </S.StudentDataSubTitle>
          </S.StudentDataContainer>

          <S.StudentDataContainer>
            <S.StudentDataTitle>Logradouro</S.StudentDataTitle>
            <S.StudentDataSubTitle>
              {user.address_street || 'Não informado'}
            </S.StudentDataSubTitle>
          </S.StudentDataContainer>

          <S.StudentDataContainer>
            <S.StudentDataTitle>Cidade</S.StudentDataTitle>
            <S.StudentDataSubTitle>
              {user.address_city || 'Não informado'}
            </S.StudentDataSubTitle>
          </S.StudentDataContainer>

          <S.StudentDataContainer>
            <S.StudentDataTitle>CEP</S.StudentDataTitle>
            <S.StudentDataSubTitle>
              {user.address_zip_code || 'Não informado'}
            </S.StudentDataSubTitle>
          </S.StudentDataContainer>

          <S.StudentDataContainer>
            <S.StudentDataTitle>Complemento</S.StudentDataTitle>
            <S.StudentDataSubTitle>
              {user.address_complement || 'Não informado'}
            </S.StudentDataSubTitle>
          </S.StudentDataContainer>

          <S.StudentDataContainer>
            <S.StudentDataTitle>Estado</S.StudentDataTitle>
            <S.StudentDataSubTitle>
              {user.address_state || 'Não informado'}
            </S.StudentDataSubTitle>
          </S.StudentDataContainer>

          <S.StudentDataContainer>
            <S.StudentDataTitle>Número</S.StudentDataTitle>
            <S.StudentDataSubTitle>
              {user.address_number || 'Não informado'}
            </S.StudentDataSubTitle>
          </S.StudentDataContainer>
        </S.StudentDataColumn>

        <S.StudentDataColumn>
          <S.StudentDataContainer>
            <S.StudentDataTitle>Controle de acesso</S.StudentDataTitle>
            <S.StudentDataSubTitle>
              {user.student?.status === 'active' ? 'Liberado' : 'Bloqueado'}
            </S.StudentDataSubTitle>
          </S.StudentDataContainer>

          <S.StudentDataContainer>
            <S.StudentDataTitle>Observações do professor</S.StudentDataTitle>
            <S.StudentDataSubTitle>
              {user.student?.observations || 'Nenhuma observação'}
            </S.StudentDataSubTitle>
          </S.StudentDataContainer>

          <S.StudentDataContainer />
          <S.StudentDataContainer />
          <S.StudentDataContainer />
        </S.StudentDataColumn>
      </S.Main>
    </S.Container>
  );
};

export default StudentDetails;
